module.exports = __webpack_public_path__ + "media/images/icons/paper_plane-63bc65f1536bfa20b17eb8b5704930c9.svg";